import styled from "@emotion/styled";

export const HeaderWrapper = styled.div`
  display: flex;
  gap: 32px;
  padding: 12px 24px;
  background-color: var(--component-color-fill-alternative);
  border-radius: 12px;
  align-items: center;
  min-width: 832px;
`;

export const ProfileHeader = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  flex: 1;
`;

export const PermissionHeader = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  min-width: 160px;
  max-width: 200px;
`;

export const InviteHeader = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
`;
